// 손 소품: 때밀이 장갑, 효자손. 프로토타입 1169–1170, equipHand 3767–3775, placeScratcher 3582–3590.
import * as THREE from 'three';
import { S } from '../engine/geometry';
import { plush } from '../engine/materials';
import type { CapyModel } from '../capy/model';

const MITT_MAT = new THREE.MeshStandardMaterial({
  roughness: 0.95,
  map: (() => {
    const c = document.createElement('canvas'); c.width = 128; c.height = 160; const x = c.getContext('2d')!;
    x.fillStyle = '#3FA34D'; x.fillRect(0, 0, 128, 160); x.strokeStyle = 'rgba(20,80,30,0.55)'; x.lineWidth = 1.5;
    for (let i = -160; i < 160; i += 8) { x.beginPath(); x.moveTo(i, 0); x.lineTo(i + 160, 160); x.stroke(); x.beginPath(); x.moveTo(i + 160, 0); x.lineTo(i, 160); x.stroke(); }
    x.fillStyle = '#161616'; x.fillRect(0, 118, 128, 10); x.fillRect(0, 136, 128, 10);
    return new THREE.CanvasTexture(c);
  })(),
});
const SCRATCH_MAT = plush('#B07A45', '#D8A070', 0.06);

/** 오른쪽 앞발을 장갑으로 바꾼다. 반환한 메쉬를 지우면 원래대로 (paw.visible = true). */
export function makeMitt(c: CapyModel): THREE.Mesh {
  const m = new THREE.Mesh(new THREE.BoxGeometry(0.4, 0.5, 0.2), MITT_MAT);
  const paw = c.paws[0]!;
  m.position.copy(paw.position); m.position.y -= 0.03;
  paw.parent!.add(m); paw.visible = false;
  return m;
}

export interface Scratcher { g: THREE.Group; stick: THREE.Group; hand: THREE.Group }

/** 효자손. 방의 월드에 붙이고 매 프레임 placeScratcher로 앞발에 맞춘다. */
export function makeScratcher(world: THREE.Object3D): Scratcher {
  const g = new THREE.Group(), stick = new THREE.Group(); g.add(stick);
  const sm = new THREE.Mesh(new THREE.CylinderGeometry(0.022, 0.026, 1, 8), SCRATCH_MAT); sm.position.y = 0.5; stick.add(sm);
  const hand = new THREE.Group(); g.add(hand);
  const palm = new THREE.Mesh(S(0.06, 12, 8), SCRATCH_MAT); palm.scale.set(1.3, 0.6, 1); palm.position.set(0, 0.0, 0.02); hand.add(palm);
  [-0.045, 0, 0.045].forEach((x) => { const f = new THREE.Mesh(new THREE.CylinderGeometry(0.014, 0.014, 0.08, 6), SCRATCH_MAT); f.position.set(x, 0.03, 0.07); f.rotation.x = 1.1; hand.add(f); });
  world.add(g);
  return { g, stick, hand };
}

const SC_Y = new THREE.Vector3(0, 1, 0), scP = new THREE.Vector3(), scT = new THREE.Vector3(), scD = new THREE.Vector3(), scQ = new THREE.Quaternion(), scM = new THREE.Matrix4();

/** 효자손을 앞발에 들려 준다. 긁는 중(scratchT)이면 귀 뒤(머리 옆 뒤쪽)를 향해 뻗어 앞뒤로 문지른다. */
export function placeScratcher(s: Scratcher, c: CapyModel, scratchT: number | undefined, t: number): void {
  s.g.visible = c.root.visible;
  c.root.updateMatrixWorld(true); c.paws[0]!.getWorldPosition(scP);
  let len = 0.82;
  if (scratchT) { const w = Math.sin(t * 9); c.headG.localToWorld(scT.set(0.79, 0.12 + 0.05 * w, -0.3 + 0.1 * w)); scD.copy(scT).sub(scP); len = Math.max(0.35, scD.length()); scD.normalize(); }
  else { scM.extractRotation(c.paws[0]!.matrixWorld); scD.set(0, 1, 0).applyMatrix4(scM).normalize(); }
  s.g.position.copy(scP); scQ.setFromUnitVectors(SC_Y, scD); s.g.quaternion.copy(scQ);
  s.stick.scale.set(1, len, 1); s.hand.position.set(0, len, 0); s.hand.rotation.set(scratchT ? 0.9 : 0.4, 0, 0);
}
